import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconFlag = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.43262 16.6667V6.66667C3.43262 5.18543 4.6629 4 6.16235 4H11.784C12.0428 4 12.2915 4.10033 12.4778 4.27989L13.0522 4.833L20.0002 4.83333C20.7107 4.83333 21.1816 5.54679 20.9355 6.18789L20.8878 6.29393L18.5322 10.833L20.8878 15.3727C21.215 16.0034 20.7987 16.75 20.1163 16.8269L20.0002 16.8333H12.6488C12.39 16.8333 12.1413 16.733 11.955 16.5534L11.3802 16H6.16235C5.78544 16 5.48635 16.2579 5.43912 16.578L5.43262 16.6851V20C5.43262 20.5523 4.9849 21 4.43262 21C3.91978 21 3.49711 20.614 3.43934 20.1166L3.43262 20V16.6667ZM13.2164 6.8333V10C13.2164 10.5523 12.7687 11 12.2164 11C11.7036 11 11.2809 10.614 11.2231 10.1166L11.2164 10V6H6.16235C5.75119 6 5.43262 6.30696 5.43262 6.66667L5.43218 14.097L5.4929 14.0809C5.65374 14.0413 5.82012 14.0156 5.99058 14.0052L6.16235 14H11.784C12.0428 14 12.2915 14.1003 12.4778 14.2799L13.0522 14.833H18.3542L16.518 11.2939C16.3869 11.0412 16.3705 10.7466 16.4688 10.4834L16.518 10.3727L18.3542 6.833L13.2164 6.8333Z"
        />
      </svg>
    );
  }
);
